var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import './ControlledTabContainer.css';
export default function ControlledTabContainer(props) {
    return (_jsx("div", __assign({ className: "ControlledTabContainer", style: props.style }, { children: React.Children.map(props.children, function (child) {
            if ((props.activeTab !== child.props.tabID) && props.singleMount) {
                return null;
            }
            if (!child.props.hidden) {
                return (_jsx("div", __assign({ className: 'tabWrapper', style: props.activeTab === child.props.tabID ? {} : { display: 'None' } }, { children: child }), void 0));
            }
            else
                return null;
        }) }), void 0));
}
//# sourceMappingURL=ControlledTabContainer.js.map